module.exports = __webpack_public_path__ + "static/media/report-flag.5cc62225.svg";